<template>
  <div id="home">
    <h2>Welcome to the Taylor Swift Lyrics Quiz!</h2>
    <p>
      Think you know all the songs? Test your knowledge with these
      finish-the-lyric-style quizzes!
    </p>
    <p>
      <b>Disclaimer:</b> These are probably the toughest Taylor Swift lyrics
      quizzes that you will find on the internet, proceed with caution...
    </p>
    <div class="button-menu" style="border-bottom: none">
      <button
        @click="startPress(`daily`)"
        class="daily"
        v-text="`Daily Quiz (#${dailyNum}) - 5 lines`"
      ></button>
      <button
        @click="startPress(`eras`)"
        class="eras"
        v-text="`Eras Tour Setlist Quiz - 9 lines, 9 eras`"
      ></button>
    </div>
    <div class="button-menu">
      <button @click="startPress(0)" class="other">
        💃💃 Play with friends 💃💃
      </button>
      <button @click="startPress(1)" class="other">
        🤓 Freeplay - 13 lines 🤓
      </button>
      <button @click="startPress(2)" class="other">
        🥳 Sing it in the chorus 🥳
      </button>
      <button @click="startPress(3)" class="other">
        😤 Let it out in the verse 😤
      </button>
      <button @click="startPress(4)" class="other">🏆 Bridgeageddon 🏆</button>
      <button @click="startPress(5)" class="other">
        😍 We love a pre-chorus 😍
      </button>
      <button @click="startPress(6)" class="other">
        🌅 Sacred (new) beginnings 🌅
      </button>
      <button @click="startPress(7)" class="other">
        📖 Endings we'd never change 📖
      </button>
      <button @click="startPress(8)" class="tloasg">
        The Life of a Showgirl
      </button>
      <button @click="startPress(9)" class="ttpd">
        The Tortured Poets Department
      </button>
      <button @click="startPress(10)" class="midnights">Midnights</button>
      <button @click="startPress(11)" class="evermore">evermore</button>
      <button @click="startPress(12)" class="folklore">folklore</button>
      <button @click="startPress(13)" class="lover">Lover</button>
      <button @click="startPress(14)" class="reputation">Reputation</button>
      <button @click="startPress(15)" class="nineteen">
        1989 (Taylor's Version)
      </button>
      <button @click="startPress(16)" class="red">
        Red (Taylor's Version)
      </button>
      <button @click="startPress(17)" class="speak">
        Speak now (Taylor's Version)
      </button>
      <button @click="startPress(18)" class="fearless">
        Fearless (Taylor's Version)
      </button>
      <button @click="startPress(19)" class="debut">Debut</button>
      <p>
        <b>Note:</b> All of these quizzes (except 'Play with friends' and the
        Daily Quiz) are autogenerated each time, so you can play them over and
        over again!
      </p>
    </div>

    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin: 12px 0 16px;
      "
    >
      <p>
        <b>Enjoying this site?</b>
      </p>
      <a
        href="https://www.buymeacoffee.com/figmargaux"
        target="_blank"
        @click="countBMC"
        class="bmc"
        >Buy me a coffee</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomePage",
  data() {
    return {
      started: true,
      checking: false,
      end: false,
    };
  },
  created() {
    this.checking = false;
    this.started = false;
    this.dailyNum = this.getDiff();
    this.auDate = new Date()
      .toLocaleString("en-US", {
        timeZone: "America/New_York",
      })
      .split(", ")[0]
      .split("/")
      .join("");
  },
  computed: {
    ...mapGetters({
      curr_line: "getCurrentLine",
      input: "getInput",
      curr_sim: "getCurrentSimilarity",
      mode: "getMode",
      title: "getTitle",
      q_num: "getQNum",
      q_bound: "getQBound",
      avgSim: "getAvgSim",
      numCorrect: "getNumCorrect",
    }),
  },
  methods: {
    countBMC() {
      window.goatcounter.count({
        path: `Click BMC - Home`,
        title: "Action",
        event: true,
      });
    },
    startPress(mode) {
      if (mode == 0) {
        this.$router.push({ name: "friends" });
      } else if (mode[0] == "d") {
        this.$router.push({
          name: "daily-quiz",
        });
      } else if (mode[0] == "e") {
        this.$router.push({
          name: "eras-quiz",
        });
      } else {
        this.$router.push({ name: "quiz", params: { mode: mode } });
      }
    },
    datediff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },
    parseDate(str) {
      var mdy = str.split("/");
      return new Date(mdy[2], mdy[0] - 1, mdy[1]);
    },
    getDiff() {
      return this.datediff(
        this.parseDate("5/5/2023"),
        this.parseDate(
          new Date()
            .toLocaleString("en-US", {
              timeZone: "America/New_York",
            })
            .split(", ")[0]
        )
      );
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 50px;
}
body {
  max-width: 900px;
  margin: 0 auto;
  padding: 5% 5% 0% 5%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.button-menu {
  border-width: 2px;
  border-style: solid;
  border-image: linear-gradient(
      45deg,
      #f79533,
      #f37055,
      #ef4e7b,
      #a166ab,
      #5073b8,
      #1098ad,
      #07b39b,
      #6fba82
    )
    1;
  border-image-slice: 1 0 1 0;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;

  button {
    cursor: pointer;
    margin: 0px auto;
    max-width: 600px;
    width: 100%;
    padding: 12px;

    font-size: 1em;
    font-style: bold;
    color: white;
    background-color: black;
    border-radius: 8px;
    border: none;
    outline: none;
    :focus {
      border: 1px solid black;
    }
  }
}

.bmc {
  background-color: #ffdd00;
  padding: 4px 12px;
  border-radius: 8px;
  color: black;
  text-decoration: none;
  font-weight: bold;
}

.bmc:hover {
  background-color: #ffe019;
}
</style>
